import { NavLink, useLocation } from "react-router-dom";
import { MessageSquare, FileText, Calculator, Briefcase, Settings } from "lucide-react";

type Item = { to: string; label: string; icon: React.ElementType<{ className?: string }> };

const ITEMS: Item[] = [
  { to: "/casos",        label: "Casos",   icon: Briefcase     },
  { to: "/melhorar-texto",   label: "Melhore",     icon: FileText      },
  { to: "/chat-juridico", label: "Chat",   icon: MessageSquare },
  { to: "/calculos",     label: "Cálculos",  icon: Calculator    },
  { to: "/configuracoes",label: "Config.", icon: Settings      },
];

export default function ModernMobileMenu() {
  const location = useLocation();
  
  // Não mostrar o menu na página inicial
  if (location.pathname === "/") {
    return null;
  }
  
  return (
    <div id="mmm-container" className="mmm-container" role="navigation" aria-label="Menu principal (mobile)">
      <nav className="mmm-nav">
        {ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) => "mmm-item" + (isActive ? " is-active" : "")}
            aria-label={label}
          >
            <Icon className="mmm-icon" />
            <span className="mmm-text">{label}</span>
            <span className="mmm-underline" aria-hidden="true" />
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
